import { View, Text, Image, StyleSheet, Linking, Platform } from "react-native"
import Swiper from "react-native-swiper/src";
import { loadFeaturedOffers } from "../../redux/actions/OfferActions";
import { useSelector } from "react-redux";
import React from "react";
import Colors from "../../utilities/Color.js";
import { Shadow } from "react-native-shadow-2";
import GenericButton from "../../components/GenericButton.js"

export default function FeaturedOffers() {
    const offersLoaded = useSelector((state) => state.offers.featuredOffersLoaded);
    const offers = useSelector((state) => state.offers.featuredOffers);
    const loadingIcon = require("../../assets/res/Loading_Screen_blue.gif");
    React.useEffect(() => {
        if (!offersLoaded) {
            loadFeaturedOffers()
        }
    }, [offersLoaded])
    return (
        <View style={styles.mainContainer}>
            {offersLoaded === true && offers != undefined ?
                <Shadow
                    distance={2}
                    startColor="#44a1cd"
                    endColor={Colors.MIDBLUE}
                    offset={[0, 0]}
                    style={styles.shadowcorners}
                >
                    <View style={styles.swiperContainer} >
                        <Swiper
                            showsButtons={false}
                            horizontal={true}
                            showsPagination={false}
                            autoplay={true}
                            autoplayTimeout={5}
                            activeDotColor="#FFC72C">
                            {offers.map((offer) => {
                                return (
                                    <View key={offer.id}>
                                        <View style={styles.topContainer}>
                                            <Image
                                                style={styles.bigImageThumbnail}
                                                source={{ uri: offer.coverArt }}
                                            />
                                        </View>
                                        <View style={styles.bottomContainer}>
                                            <View style={styles.leftContainer} >
                                                <Image
                                                    style={styles.logoImageThumbnail}
                                                    source={{ uri: offer.logo }}
                                                />
                                            </View >
                                            <View style={styles.middleContainer} >
                                                <Text style={styles.textTitle}>
                                                    {offer.title}
                                                </Text>
                                                <Text style={styles.textAdvertise}>
                                                    {offer.advertiser}
                                                </Text>
                                            </View >
                                            <View style={styles.rightContainer} >
                                                {/* This commented part can be removed in 22/10/23 */}
                                                {/* <TouchableOpacity
                                                    style={styles.submitYellowButtonStyle}
                                                    onPress={() => Platform.OS === "web" ? window.open(offer.trackingUrl, "_blank")
                                                        : Linking.openURL(offer.trackingUrl)}
                                                >
                                                    <Text style={[styles.TextButtonStyle, { color: "black" }]}>
                                                        ONLINE OFFER
                                                    </Text>
                                                </TouchableOpacity> */}
                                                <GenericButton
                                                    buttonText='ONLINE OFFER'
                                                    onPress={() => Platform.OS === "web" ? window.open(offer.trackingUrl, "_blank")
                                                        : Linking.openURL(offer.trackingUrl)}
                                                    buttonHeight={40}
                                                    buttonTextSize={10}
                                                    buttonWidth={100}
                                                />
                                            </View >
                                        </View>
                                    </View>
                                )
                            })}
                        </Swiper>
                    </View>
                </Shadow>
                :
                <View style={styles.LoadingContainer}>
                    <Image style={styles.loadingImage} source={loadingIcon} />
                </View>
            }</View>
    )
}
const styles = StyleSheet.create({
    LoadingContainer: {
        height: "100%",
        flex: 1,
        alignItems: "center",
        justifyContent: "center",
        paddingTop: 50,
    },
    loadingImage: {
        height: 25,
        width: 25,
    },
    swiperContainer: {
        height: 260,
        backgroundColor: "#ffffff"
    },
    topContainer: {
        height: 200,
    },
    bigImageThumbnail: {
        height: 200,
        width: "100%",
        resizeMode: "cover",
    },
    bottomContainer: {
        height: 60,
        alignItems: "center",
        flexDirection: "row",
        backgroundColor: Colors.WHITE,
        paddingRight: 5,
        paddingLeft: 5,
        position: "absolute",
        bottom: -60,
        width: "100%",
        borderTopColor: Colors.LTBLUE,
        borderTopWidth: 1,
    },
    leftContainer: {
        flex: 1.2,
    },
    logoImageThumbnail: {
        height: 50,
        width: 50,
        resizeMode: "contain",
    },
    middleContainer: {
        flex: 4,
    },
    textAdvertise: {
        textAlign: "left",
        fontFamily: "montserrat-bold",
        fontSize: 9,
        textTransform: "uppercase",
        paddingBottom: 2,
    },
    textTitle: {
        textAlign: "left",
        fontFamily: "montserrat-bold",
        fontSize: 9,
        textTransform: "uppercase",
        paddingBottom: 2,
        color: Colors.MIDBLUE,
    },
    textOffer: {
        textAlign: "left",
        fontFamily: "montserrat-bold",
        fontSize: 11,
        textTransform: "uppercase",
        paddingBottom: 2,
    },
    rightContainer: {
        flex: 2.2,
    },
    // This commented part can be removed in 22/10/23 
    // submitYellowButtonStyle: {
    //     borderRadius: 50,
    //     backgroundColor: Colors.YELLOW,
    //     justifyContent: "center",
    //     height: 40,
    //     paddingLeft: 5,
    //     paddingRight: 5,
    // },
    // TextButtonStyle: {
    //     color: "#ffffff",
    //     textAlign: "center",
    //     fontFamily: "montserrat-bold",
    //     fontSize: 10,
    //     lineHeight: 10,
    // },
    shadowcorners: {
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: 0,
        padding: 2,
        width: "100%",
        alignSelf: "center",
        height: 263,
    },
})